import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, lastValueFrom, timeout } from 'rxjs';

import { AppConfigService } from '~/core/services/appconfig.service';
import { AppConfig } from '~/core/models/appconfig';

const TIMEOUT: number = 30000;

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    private config: AppConfig;
    private apiHeader: HttpHeaders = new HttpHeaders({ "accept": "application/json", "Content-Type": "application/json" });

    constructor(
        private http: HttpClient,
        private appconfigService: AppConfigService
    ) {
        this.config = this.appconfigService.getConfig();
    }

    public Get<T>(endpoint: string, headers: HttpHeaders = this.apiHeader, callTimeout: number = TIMEOUT): Observable<T> {
        // Browsers may trigger a CORS preflight if Content-Type is sent on GET.
        const getHeaders = headers.has('Content-Type') ? headers.delete('Content-Type') : headers;
        return this.http.get<T>(`${this.config.apiUrl}/${endpoint}`, { headers: getHeaders }).pipe(timeout(callTimeout));
    }

    public GetBlob(endpoint: string, headers: HttpHeaders = this.apiHeader, callTimeout: number = TIMEOUT): Observable<Blob> {
        const getHeaders = headers.has('Content-Type') ? headers.delete('Content-Type') : headers;
        return this.http.get(`${this.config.apiUrl}/${endpoint}`, { headers: getHeaders, responseType: 'blob' }).pipe(timeout(callTimeout));
    }

    public Post<T>(endpoint: string, body?: any, headers: HttpHeaders = this.apiHeader, callTimeout: number = TIMEOUT): Observable<T> {
        return this.http.post<T>(`${this.config.apiUrl}/${endpoint}`, body, { headers: headers }).pipe(timeout(callTimeout));
    }

    public Put<T>(endpoint: string, body?: any, headers: HttpHeaders = this.apiHeader, callTimeout: number = TIMEOUT): Observable<T> {
        return this.http.put<T>(`${this.config.apiUrl}/${endpoint}`, body, { headers: headers }).pipe(timeout(callTimeout));
    }

    public Delete<T>(endpoint: string, body?: any, headers: HttpHeaders = this.apiHeader, callTimeout: number = TIMEOUT): Observable<T> {
        return this.http.request<T>('DELETE', `${this.config.apiUrl}/${endpoint}`, { headers, body }).pipe(timeout(callTimeout));
    }

    public GetExternal<T>(url: string, callTimeout: number = TIMEOUT): Observable<T> {
        return this.http.get<T>(url).pipe(timeout(callTimeout));
    }
}
